var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.75 2.25L6 6L9.75 9.75","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M2.25 2.25L6 6L2.25 9.75","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Close.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Close;

Close.default = Close;
